export const featureFlagsType = 'FEATURE_FLAG';

export const featureFlags = {
	faithlifeTv: [],
	faithlifeTvTeam: [],
	faithlifeEmployees: [],
};
